export default {
	CARD: 'card',
}